import KeenSlider from 'keen-slider';
if (!customElements.get('ia-slideshow')) {

  class IASlideshow extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.currentSlideElement = null;
      this.prevButton = null;
      this.nextButton = null;
      this.autoplay = this.getAttribute('data-autoplay') === 'true';
      this.centeredMobile = this.getAttribute('data-centered-mobile') === 'true';
    }
  
    connectedCallback() {
      this.initializeSlideshow();
    }
  
    disconnectedCallback() {
      if (this.slider) {
        this.slider.destroy();
      }
    }
  
    initializeSlideshow() {
      const carousel = this.querySelector('.ia-slideshow__carousel');
      this.currentSlideElement = this.querySelector('.js-ia-slideshow-current');
      this.prevButton = this.querySelector('.js-ia-slideshow-prev');
      this.nextButton = this.querySelector('.js-ia-slideshow-next');
  
      if (!carousel) {
        console.warn('IA Slideshow: Carousel element not found');
        return;
      }
      this.slider = new KeenSlider(carousel, {
        loop: false,
        autoplay: this.autoplay,
        slides: {
          perView: this.dataset.perViewDesktop || 1,
          spacing: this.dataset.spacingDesktop || 0,
        },
        breakpoints: {
          '(max-width: 1023px)': {
            slides: {
              perView: this.dataset.perViewMobile || 1,
              spacing: this.dataset.spacingMobile || 0,
              origin: this.centeredMobile ? 0.25 : undefined,
            },
          },
        },
        created: () => {
          console.log('>>> IA Slideshow created');
        }
      });
  
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.slider.prev();
        });
      }
  
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.slider.next();
        });
      }
  
      this.slider.on('slideChanged', (slide) => {
        if (this.slider?.track?.details?.rel >= 0 && this.currentSlideElement) {
          this.currentSlideElement.textContent = this.slider.track.details.rel + 1;
        }
      });
    }
  
    next() {
      if (this.slider) {
        this.slider.next();
      }
    }
  
    prev() {
      if (this.slider) {
        this.slider.prev();
      }
    }
  
    goToSlide(index) {
      if (this.slider) {
        this.slider.moveToIdx(index);
      }
    }
  
    destroy() {
      if (this.slider) {
        this.slider.destroy();
        this.slider = null;
      }
    }
  }
  
  
  customElements.define('ia-slideshow', IASlideshow); 
}